<template>
  <form @submit.prevent="this.doForm">
    <div :class="{active: $data.formType == 'sign', 'f-type': true}" @click.prevent="this.toggleForm('sign')">
      {{ $t('login.signUp') }}
    </div>
    <div :class="{active: $data.formType == 'login', 'f-type': true}" @click.prevent="this.toggleForm('login')">
      {{ $t('login.login') }}
    </div>
    <label>
      <span>
        {{ $t('login.username') }}
      </span>
      <input
          type="text"
          v-model.trim="username"
          required
          :class="{'error': failedLogin}"
          @input="this.$data.failedLogin = false"
      >
    </label>
    <label>
      <span>
        {{ $t('login.password') }}
      </span>
      <input
          type="password"
          v-model.trim="password"
          required
          :class="{'error': failedLogin}"
          @input="this.$data.failedLogin = false"
      >
    </label>
    <label v-if="$data.formType == 'sign'">
      <span>
        {{ $t('login.email') }}
      </span>
      <input type="email" for="email" v-model.trim="email" @blur="validateEmail" :class="{'error': emailError}" >
    </label>
    <!-- Причина отказа сервера (занятый ник, короткий пароль, неверные данные). Раньше форма только
         красила поля и молча уходила на главную — игрок не понимал, что не так. -->
    <div v-if="formError" class="form-error">{{ formError }}</div>
    <div>
      <input type="submit" :value="$t('login.submit')">
    </div>
  </form>
</template>

<script>
export default {
  name: "LoginForm",
  data: () => ({
    username: '',
    password: '',
    email: '',
    emailError: false,
    formType: 'login',
    failedLogin: false,
    formError: ''  // текст отказа с сервера (переведён), показывается под полями
  }),
  methods: {
    validateEmail() {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(this.$data.email)) {
        this.$data.emailError = false
      } else {
        this.$data.emailError = true;
      }
    },
    toggleForm(formtype){
      this.$data.formType = formtype
    },
    async doForm(){
      this.$data.formError = '';
      // 🔴 УХОДИМ НА ГЛАВНУЮ ТОЛЬКО ПОСЛЕ УСПЕХА. Раньше переход стоял сразу после dispatch (форма
      // не ждала ответа) — при отказе игрока уносило на главную неавторизованным, а причина отказа
      // оставалась в форме, которую он уже не видел. С требованиями к паролю это стало тупиком.
      if (this.$data.formType == 'login'){
        await this.$store.dispatch('LOGIN', {
          payload: this.$data,
          app: this
        })
      }else if(this.$data.formType == 'sign'){
        await this.$store.dispatch('CREATE_ACCOUNT', {
          payload: this.$data,
          app: this
        })
      }
      if (!this.$data.formError) this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped lang="scss">
  form{
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  div.f-type{
    grid-column-start: auto;
    grid-column-end: auto;
    font-size: 18px;
    font-family: inherit;
    border: none;
    background: url("../assets/category.webp") no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    // по бокам отступ больше: у фона-плашки узорные края, и надпись не должна на них наезжать
    padding: 1em 1.7em;
    color: #fff;
    text-transform: uppercase;
    // ПЛАШКА ТЯНЕТСЯ ПОД НАДПИСЬ: раньше стояла жёсткая ширина 50%, и русское «РЕГИСТРАЦИЯ» (вдвое
    // длиннее английского SIGN UP) вылезало за фон. min-width сохраняет прежний вид коротких надписей.
    width: fit-content;
    min-width: 50%;
    max-width: 100%;
    white-space: nowrap;
    margin: 1em auto;
    transition: ease filter 0.3s;
    cursor: pointer;
    &:hover{
      font-weight: 600;
    }
    &.active{
      filter: contrast(150%);
      color: yellow;
      cursor: default;
      &:hover{
        font-weight: 400;
      }
    }
  }
  label, div{
    grid-column-start: 1;
    grid-column-end: -1;
    width: 100%;
  }
  label{
    justify-content: space-between;
    margin-bottom: 1em;
    font-size: 24px;
    display: flex;
    &>*{
      width: 300px;
      padding: 0.5em 1em;
      display: block;
      box-sizing: border-box;
      flex-shrink: 0;
      background: url("../assets/inputbg.webp") ;
      background-size: 100% 100%;
      border: 0;
      color: #fff;
    }
    input{
      font-size: 16px;
      text-align: center;
      &.error{
        outline: 5px solid red;
        outline-offset: -5px;
      }
      &:focus, &:active {
        outline: none;
      }
    }
  }
  // Текст отказа сервера — на всю ширину формы (она двухколоночная), над кнопкой.
  .form-error{
    grid-column: 1 / -1;
    margin: 0.4em auto 0;
    max-width: 90%;
    color: #ff9a9a;
    font-size: 14px;
    line-height: 1.3;
    text-align: center;
    overflow-wrap: anywhere;
  }
  input{
    &[type='submit']{
      font-size: 16px;
      font-family: inherit;
      border: none;
      background: url("../assets/category.webp") no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      padding: 1em 3em;
      color: yellow;
      text-transform: uppercase;
      margin: 1em auto;
      transition: ease filter 0.3s;
      cursor: pointer;
      &:hover{
        filter: contrast(150%);
      }
    }
  }

  @media (max-width: 720px) {
    form{
      display: block;
      label{
        flex-wrap: wrap;
        width: 90%;
        margin: 0 auto 10px;
        padding: 0 10px;
        box-sizing: border-box;
        font-size: 17px;          // было 24px — на мобилке слишком крупно
        &>*{
          width: 100%;
        }
        span{ padding: 0.3em 0.5em; }
        input{
          display: block;
          padding: 0.8em 1em;
        }
      }
    }
    div{
      &.f-type{
        display: inline-block;
        width: fit-content;      // как на десктопе: плашка растягивается под длинную надпись
        min-width: 44%;
        max-width: 100%;
        margin: 0 0 16px;
        font-size: 16px;
        padding: 10px 18px;   // те же поля под узорные края плашки, что и на десктопе
      }
    }
    // Кнопка OK на мобилке (значения из тюнера)
    input[type='submit']{
      width: 80%;
      padding: 14px 10px;
      margin: 15px auto 0;
      font-size: 16px;
    }
  }
</style>
